<template>
  <TemplateBase>
    <client-only>
      <main v-show="!hasUser" class="col-span-full row-start-2 py-6 md:py-12">
        <div class="mx-auto px-4 max-w-lg sm:p-8 sm:bg-white sm:border-b-2 sm:border-solid sm:border-app-lime sm:rounded-xl">
          <MoleculeUserLoginForm />

          <div>
            <AtomLink :url="{ name: 'account-password-reset' }" class="group inline-block mb-6 mr-6 font-bold border-b border-solid border-app-green">
              {{ t_('reset') }}
              <AtomIconArrowRight class="inline-block ml-1 w-3 h-3 transform group-hover:translate-x-1 transition duration-200" />
            </AtomLink>

            <AtomLink :url="{ name: 'account-register' }" class="group inline-block font-bold border-b border-solid border-app-green">
              {{ t_('register') }}
              <AtomIconArrowRight class="inline-block ml-1 w-3 h-3 transform group-hover:translate-x-1 transition duration-200" />
            </AtomLink>
          </div>
        </div>
      </main>
    </client-only>
  </TemplateBase>
</template>

<script setup lang="ts">
import { setupRequireNoUser } from '~/composables/user'
import { setCacheControlHeader, setupTranslationPrefixer } from '~/composables/util'
import { getSiteConfig } from '~/composables/craft'
import { useNavigationStore } from '~/store/navigation'

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    nl: '/ikzoekbaas/account/inloggen',
  },
})

const { hasUser } = setupRequireNoUser()
const { t_ } = setupTranslationPrefixer('account-login')

const route = useRoute()
const { site } = getSiteConfig(route)
const navigationStore = useNavigationStore()
await navigationStore.fetch(site)
setCacheControlHeader()
</script>
